// Lawyer Portal entry point — env-configurable so it can be swapped to
// `/practice` or moved to lawyers.advoset.in without code changes.
export const LAWYER_BASE = (process.env.REACT_APP_LAWYER_PATH || "/lawyer-portal").replace(/\/+$/, "");
export const LAWYER_LOGIN_PATH = `${LAWYER_BASE}/login`;
